// extracted by mini-css-extract-plugin
export default {"container":"Login_container__jTsVi","form":"Login_form__-eVJi","data":"Login_data__QVDfu","title":"Login_title__f+QN2","button":"Login_button__C5dSv","error":"Login_error__wXH61"};